const embedTextElement = $('.js-appointment-text');
embedTextElement.text("Записаться на приём");

